/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "@kubb/plugin-client/clients/axios";
import type {
	GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest,
	GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationResponse,
	GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParams,
	GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost422,
} from "../models/GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost.ts";
import type {
	RequestConfig,
	ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

export const getAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationKey =
	() => [{ url: "/v1/bitcoin/addresses/latest-txid" }] as const;

export type GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationKey =
	ReturnType<
		typeof getAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationKey
	>;

/**
 * @description Get the latest transaction ID for each Bitcoin address.Args:    addresses: List of Bitcoin addresses (max 100)    network: Network to use (REGTEST or MAINNET)Returns:    Dictionary mapping each address to its latest transaction ID (or null if no transactions)
 * @summary Get Addresses Latest Txid
 * {@link /v1/bitcoin/addresses/latest-txid}
 */
export async function getAddressesLatestTxidV1BitcoinAddressesLatestTxidPostHook(
	params: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParams,
	data?: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest,
	config: Partial<
		RequestConfig<GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest>
	> & { client?: typeof client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<
		GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationResponse,
		ResponseErrorConfig<GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost422>,
		GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest
	>({
		method: "POST",
		url: "/v1/bitcoin/addresses/latest-txid",
		baseURL: "https://api.sparkscan.io",
		params,
		data,
		...requestConfig,
	});
	return res.data;
}

/**
 * @description Get the latest transaction ID for each Bitcoin address.Args:    addresses: List of Bitcoin addresses (max 100)    network: Network to use (REGTEST or MAINNET)Returns:    Dictionary mapping each address to its latest transaction ID (or null if no transactions)
 * @summary Get Addresses Latest Txid
 * {@link /v1/bitcoin/addresses/latest-txid}
 */
export function useGetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostHook<
	TContext,
>(
	options: {
		mutation?: UseMutationOptions<
			GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationResponse,
			ResponseErrorConfig<GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost422>,
			{
				params: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParams;
				data?: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest;
			},
			TContext
		> & { client?: QueryClient };
		client?: Partial<
			RequestConfig<GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest>
		> & { client?: typeof client };
	} = {},
) {
	const {
		mutation: { client: queryClient, ...mutationOptions } = {},
		client: config = {},
	} = options ?? {};
	const mutationKey =
		mutationOptions?.mutationKey ??
		getAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationKey();

	return useMutation<
		GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationResponse,
		ResponseErrorConfig<GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost422>,
		{
			params: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParams;
			data?: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest;
		},
		TContext
	>(
		{
			mutationFn: async ({ params, data }) => {
				return getAddressesLatestTxidV1BitcoinAddressesLatestTxidPostHook(
					params,
					data,
					config,
				);
			},
			mutationKey,
			...mutationOptions,
		},
		queryClient,
	);
}
